import className from 'classnames/bind';
import styles from './Chatbot.module.scss';
import Script from 'next/script';

let cx = className.bind(styles);

export function Chatbot() {
	function launchChat() {
		window.adaEmbed.toggle();
	}
	return (
		<>
			<Script src="https://static.ada.support/embed2.js" data-handle="netspend" id="__ada" strategy="lazyOnload" />
			<button className={cx('ada-chatbot-btn')} onClick={launchChat}>
				<div className={cx('ada-chatbot-btn--text', 'sr-only')}>Chat with a virtual assistant</div>
			</button>
		</>
	);
}
